import React, { useRef, useEffect, useState } from "react";
import { useReactToPrint } from "react-to-print";
import { withSidebar } from "../hoc/withSidebar.js";
import { useTranslation } from "react-i18next";
import ERPSBaseButton from "../custom/inputs/ERPSBaseButton.js";
import { useDispatch, useSelector } from "react-redux";
import Breadcrumb from "../Breadcrumb/Breadcrumb.js";
import ERPSTransactionDetails from "../custom/ERPSTransactionDetails";
import { listProps } from "../../utils/helper.js";
import { isShowBankCard } from "../../constants/TransactionSearchConstants.js";
import { HStack, ResponsiveBox, Stack } from "../primitives";

const ReviewTransactionDetails = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    location: { state },
  } = props;
  
  const transactionEnquiryData = useSelector(
    (state) => state.transactionEnquiryReducer?.transactionEnquiryData?.data
  );

  const user = useSelector((state) => state.loginUserReducer.user);
  const roleId = user?.role?.role_id;
  const printComponentRef = useRef();

  let data = transactionEnquiryData?.find(({ payment_id }) => payment_id === state.id) || {};

  const currentFiNumber = useSelector((state) => state.fiReducer?.selectedFi || user?.fiNumber);

  const handlePrint = useReactToPrint({
      content: () => printComponentRef.current
  });

  useEffect(() => {
    dispatch({ type: "UPDATE_RECALL_RETRACE_INFO_SUCCESS", data: null });
    return () => { printComponentRef.current = null };  // clean up the ref on exit
  }, []);

  return (
    <div role="main">
      <ResponsiveBox ml={3}>
        <Breadcrumb
          {...props}
          componentAccess={state?.componentAccess}
          fromDetailPage={true}
        />
      </ResponsiveBox>

      <ERPSTransactionDetails data={data} ref={printComponentRef} isShowBankCard={isShowBankCard(roleId, currentFiNumber)}/>

      <HStack spacing={2} ml={3}>
        <ERPSBaseButton
          variant="secondary"
          className="button_with_margin48"
          label={t("erps.newuser.button.back", "Back")}
          onClick={() =>
            props.history.push("/review-transactions/", {
              componentAccess: state?.componentAccess,
              fromDetailPage: true,
            })
          }
        />
        <ERPSBaseButton                  // PRINT
            variant="primary"
            className="button_with_margin48"
            label={t("erps.transactionEnquiry.page.transactionDetails.button.print")}
            onClick={handlePrint}
            ///loading={loading}
        />
      </HStack>
    </div>
  );
};

export default withSidebar(ReviewTransactionDetails);
